<div class="fz-dialog__close" mat-dialog-title>
  <button mat-icon-button (click)="onClose()">
    <mat-icon>close</mat-icon>
  </button>
</div>
<div class="dialog-container">
  <div class="content-padding">
    <div class="mat-headline-small">Upload ID Picture</div>
    <div class="mb--2 small-margin-top">
      Please upload a clear picture of your government-issued
      identification.Thank you for helping grow our community of real players!
    </div>
    <div
      *ngIf="file && (error$ | async) === ''; else errorDiv"
      class="valid-image message-box"
    >
      <div class="uploaded-image-container">
        <img [src]="imgSrc" class="uploaded-image" />
      </div>
      <div class="img-ctn">
        <div>{{ file.name }}</div>
        <div class="mat-caption grey-text error-text">{{ fileSize }}MB</div>
      </div>
    </div>

    <div
      class="upload-image-box ripple-div"
      [ngClass]="{
        'tall-button': !otherElements,
        'short-button': otherElements
      }"
      [class.disabled]="isVerifying"
      (click)="uploadImage()"
    >
      <div class="verifying-ctn flex-unset" *ngIf="!isVerifying">
        <mat-icon svgIcon="upload-icon"></mat-icon>
        <div class="orange-text">
          {{ fileUploaded ? 'Change' : 'Upload' }} ID picture
        </div>
      </div>
      <div *ngIf="!isVerifying" class="mat-caption grey-text">
        (JPG, PNG, up to 20MB)
      </div>
      <div *ngIf="isVerifying">
        <mat-spinner
          class="spinner"
          diameter="30"
          color="primary"
        ></mat-spinner>
        <div class="">Uploading picture...</div>
      </div>
    </div>

    <div class="full-width">
      <button
        mat-flat-button
        color="primary"
        class="full-width verify-button"
        (click)="verifyImage()"
        [disabled]="isVerifying"
      >
        Verify Identity
      </button>
    </div>
  </div>
</div>
<ng-template #errorDiv>
  <div *ngIf="error$ | async as error" class="error-message-image message-box">
    <div>
      <mat-icon class="error-icon">error</mat-icon>
    </div>
    <div>
      <div class="no-margin">Unable to validate your picture</div>
      <div class="mat-body-2 grey-text error-text">
        {{ getErrorText(error) }}
      </div>
    </div>
  </div>
</ng-template>
